import { inject, Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { liveLessonStateActions } from "./state/live-lesson-state.actions";
import { selectLiveLessonState } from "./state/live-lesson-state.selectors";


/**
 * Gets and provides the PCP Live Session State.
 */
@Injectable({
    providedIn: 'root',
})
export class LiveSessionStateService {

    private readonly store = inject(Store);

    readonly state$ = this.store.select(selectLiveLessonState);

    /**
     * Force fetch/request the live session state using the API or SignalR.
     */
    fetchLiveSessionState() {
        this.store.dispatch(liveLessonStateActions.fetchLiveLessonState());
    }
}
